import {
  NAVIGATION_ROUTES,
  STAFF_MANAGEMENT_STAFF_ID_QUERY_KEY,
} from "../../utils/NavigationUtils";

/** Replace with per-row PAM `admin_id` when the audit API provides it */
export const MANUAL_ACTION_STAFF_ID_PLACEHOLDER =
  "616b2590-b0c1-7011-fccb-e0830b117f8a";

export function getManualActionsStaffManagementHref(
  staffId = MANUAL_ACTION_STAFF_ID_PLACEHOLDER
) {
  return `${NAVIGATION_ROUTES.STAFF_MANAGEMENT_NEW}?${STAFF_MANAGEMENT_STAFF_ID_QUERY_KEY}=${staffId}`;
}
